import { staticPath } from "faqSrc/lib/$path";
import React from "react";
import styled, { css } from "styled-components";
import Image from "components/atoms/Image";
import IconExplode from "~/components/icons/IconExplode";
import {
  likeButtonExplode,
  likeButtonPulse,
  snsIconLabel,
} from "~/styles/CommonStyles";

type ButtonSize = "small" | "medium";
const heightMap: { [key in ButtonSize]: number } = {
  medium: 48,
  small: 40,
};
const iconSizeMap: { [key in ButtonSize]: number } = {
  medium: 28,
  small: 22,
};

interface HelpfulButtonProps {
  iconType: "solid" | "outline";
  isAnimated?: boolean;
  label?: string;
  onClick?: () => void;
  size?: ButtonSize;
}

const HelpfulButton: React.FC<HelpfulButtonProps> = ({
  iconType,
  isAnimated,
  label,
  onClick,
  size = "small",
}) => {
  return (
    <HelpfulIcon
      aria-label="Helpful Button"
      id="helpful-button"
      onClick={onClick}
      title="Helpful Button"
    >
      <IconWrap dataSize={size} dataIsAnimated={isAnimated}>
        {isAnimated && (
          <IconExplodeWrap>
            <IconExplode width={36} height={36} />
          </IconExplodeWrap>
        )}
        <Image
          alt="Helpful"
          ampLayout="fixed"
          height={iconSizeMap[size]}
          layout="fixed"
          src={
            iconType === "solid"
              ? staticPath.img.icon_heart_pink_svg
              : staticPath.img.icon_heart_outlined_svg
          }
          width={iconSizeMap[size]}
        />
      </IconWrap>
      {label && <IconLabel>{label}</IconLabel>}
    </HelpfulIcon>
  );
};

const HelpfulIcon = styled.a`
  align-items: center;
  cursor: pointer;
  display: grid;
  gap: 6px;

  &:hover {
    opacity: 0.8;
  }
`;

const IconWrap = styled.div<{ dataSize: ButtonSize; dataIsAnimated?: boolean }>`
  align-items: center;
  background-color: #fff;
  border-radius: 50%;
  border: 2px solid transparent;
  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  display: grid;
  height: ${(props) => heightMap[props.dataSize]}px;
  justify-content: center;
  margin: 0 auto;
  overflow: hidden;
  position: relative;
  width: ${(props) => heightMap[props.dataSize]}px;
  ${(props) =>
    props.dataIsAnimated &&
    css`
      > span:not(:first-child) {
        animation: 0.3s ease-in-out 0s 1 normal none running ${likeButtonPulse};
      }
    `}
`;

const IconLabel = styled.span`
  ${snsIconLabel};
`;

const IconExplodeWrap = styled.span`
  left: 3px;
  right: 0;
  bottom: 0;
  opacity: 0;
  position: absolute;
  top: 4px;
  transition: all 0.2s ease 0s;
  animation: 0.3s ease 0s 1 normal none running ${likeButtonExplode};
`;

export default HelpfulButton;
